import { render, staticRenderFns } from "./searchSnPos.vue?vue&type=template&id=04428b0a&scoped=true"
import script from "./searchSnPos.vue?vue&type=script&lang=js"
export * from "./searchSnPos.vue?vue&type=script&lang=js"
import style0 from "./searchSnPos.vue?vue&type=style&index=0&id=04428b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04428b0a",
  null
  
)

export default component.exports